import { getApiUrl } from "@repo/utils/get-api-url";
import {
  AddSavedItemsParams,
  AddSavedItemsResponse,
  GetSavedItemsParams,
  RemoveSavedItemsParams,
  SavedItems,
  UpdateSavedItemsParams,
  GetSavedItemsSummaryParams,
  GetSavedItemsSummaryResponse,
} from "./saved-items.types";

export const CUSTOMER_SAVED_LISTS_V3_PATH =
  "/customer/savedlists/v3/customers/me/lists/default";

export const getSavedItemsSummary = async (
  props: GetSavedItemsSummaryParams,
) => {
  const { chameleonRequestInstance, store, authHeader, ...searchParams } =
    props;

  const url = getApiUrl({
    path: `${CUSTOMER_SAVED_LISTS_V3_PATH}/summary`,
    searchParams: {
      store,
      ...searchParams,
    },
  });

  const response =
    await chameleonRequestInstance.get<GetSavedItemsSummaryResponse>(url, {
      headers: {
        "Content-Type": "application/json",
        "asos-c-store": store,
        Authorization: authHeader,
      },
    });

  return response.data || null;
};

export const getSavedItems = async (props: GetSavedItemsParams) => {
  const {
    chameleonRequestInstance,
    authHeader,
    expand = "ids",
    store,
    ...searchParams
  } = props;

  const url = getApiUrl({
    path: `${CUSTOMER_SAVED_LISTS_V3_PATH}/items`,
    searchParams: {
      ...searchParams,
      store,
      expand,
    },
  });

  const response = await chameleonRequestInstance.get<SavedItems>(url, {
    headers: {
      "Content-Type": "application/json",
      "asos-c-store": store,
      Authorization: authHeader,
    },
  });

  return response.data || null;
};

export const addSavedItems = async (props: AddSavedItemsParams) => {
  const {
    chameleonRequestInstance,
    authHeader,
    store,
    items,
    ...searchParams
  } = props;

  const url = getApiUrl({
    path: `${CUSTOMER_SAVED_LISTS_V3_PATH}/items`,
    searchParams: {
      store,
      ...searchParams,
    },
  });

  const response = await chameleonRequestInstance.post<AddSavedItemsResponse>(
    url,
    {
      headers: {
        "Content-Type": "application/json",
        "asos-c-store": store,
        Authorization: authHeader,
      },
      body: JSON.stringify({ items }),
    },
  );

  return response.data || null;
};

export const removeSavedItems = async (props: RemoveSavedItemsParams) => {
  const { chameleonRequestInstance, authHeader, store, itemId } = props;

  const url = getApiUrl({
    path: `${CUSTOMER_SAVED_LISTS_V3_PATH}/items/${itemId}`,
  });

  await chameleonRequestInstance.delete(url, {
    headers: {
      "Content-Type": "application/json",
      "asos-c-store": store,
      Authorization: authHeader,
    },
  });
};

export const updateSavedItems = async (props: UpdateSavedItemsParams) => {
  const { chameleonRequestInstance, authHeader, store, itemId, variantId } =
    props;

  const url = getApiUrl({
    path: `${CUSTOMER_SAVED_LISTS_V3_PATH}/items/${itemId}`,
  });

  await chameleonRequestInstance.patch(url, {
    headers: {
      "Content-Type": "application/json",
      "asos-c-store": store,
      Authorization: authHeader,
    },
    body: JSON.stringify({ variantId }),
  });
};
